<app-loading [isLoading]="isLoading"></app-loading>
<div class="container my-3" *ngIf="model">
  <h1>{{ model.page.detailName }}</h1>
  <div [innerHtml]="model.page.detailDescription | safePipe"></div>
</div>
